<div id="genericModalDialog" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="genericModalDialogLabel" [attr.inert]="!isOpen ? '' : null">
    <div class="e-modal-dialog e-modal-dialog-centered" role="document">
        <div class="e-modal-content">
                        @if (showCloseIcon) {
                            <button type="button" class="e-close" data-dismiss="modal" aria-label="Close" (click)="onCancelNotify()">
                                    <span class="fas fa-times"></span>
                            </button>
                        }
                        <div class="e-modal-header">
                                @if (modalTitleIconCss) {
                                    <span [class]="modalTitleIconCss"></span>
                                }
                                @if (modalTitle) {
                                    <h1 class="e-modal-title">{{ modalTitle }}</h1>
                                }
                                @if (modalTitleDescription) {
                                    <h2 class="e-modal-title-description">{{ modalTitleDescription }}</h2>
                                }
                        </div>
                        <div class="e-modal-body">
                            @if (modalNotificationIconMessageList.length) {
                                <div class="e-notification-messages">
                                    <p>
                                        @if (modalNotificationIconCss) {
                                            <span [class]="modalNotificationIconCss">
                                                <strong>{{ modalNotificationIconWithText }}</strong>
                                            </span>
                                        }
                                        {{ modalNotificationIconMessageHeading }}
                                    </p>
                                    <ul class="e-notification-message-list">
                                        @for (message of modalNotificationIconMessageList; track message) {
                                            <li><span>{{ message }}</span></li>
                                        }
                                    </ul>
                                </div>
                            }
                            @if (showOptionalFileNameInput) {
                                <div class="e-file-browser">
                        <div>
                        <label for="e-file-name-input">Name your file:</label>
                        <input
                            id="e-file-name-input"
                            class="e-input"
                            [value]="modalExportFileName"
                            (input)="modalExportFileName = $any($event.target).value; validateFileName()"
                            maxlength="65"
                            (keyup)="validateFileName()"
                        />
                    </div>
                                        @if (modalExportFileNameInvalid) {
                                            <div class="e-file-name-error">
                                                <span class="e-file-name-error-heading">Error:&nbsp;</span><span class="e-file-name-error-message">Invalid File Name</span>
                                            </div>
                                        }
                                    </div>
                                }
            </div>
            <div class="e-modal-footer">
                <div class="e-buttons-footer">
                    <button type="button" class="e-dialog-button e-cancel-dialog-button" data-dismiss="modal" (click)="onCancelNotify()">
                        {{ modalCancelButtonText }}
                    </button>
                    <button
                        type="button"
                        class="e-dialog-button e-submit-dialog-button"
                        (click)="onSubmitNotifyClick()"
                        [(disabled)]="modalExportFileNameInvalid"
                    >
                        {{ modalSubmitButtonText }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
